import { Injectable, NgZone } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { AppService } from '../../app-service/logic/app.service';
import { CredentialsService } from '../../credentials/logic/credentials.service';
import { NavController } from '@ionic/angular';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { RemoteActionBuilderService } from '../../remote-action-builder/remote-action-builder.service';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';
import { LocationService } from '../../location/location.service';
import { EmployeeService } from '../../employee/logic/employee.service';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import { TravelRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/travel-remote-action-builder/travel-remoteaction-builder';
import { TravelRemoteActionType } from 'src/app/_model/remote-action/remote-action-builder/travel-remote-action-builder/travel-remote-action-type';
import { BranchesService } from '../../branches/logic/branches.service';
import { JobSectionsService } from '../../job-section/logic/job-section.service';

@Injectable({
  providedIn: 'root',
})
export class NotifyTravelStartActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'nts';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private appService: AppService,
    private credentialsService: CredentialsService,
    private navigationController: NavController,
    private clientStateService: ClientStateService,
    private remoteActionBuilderService: RemoteActionBuilderService,
    private servicejobService: ServicejobsService,
    private branchesService: BranchesService,
    private locationService: LocationService,
    private employeeService: EmployeeService,
    private jobSectionsService: JobSectionsService,
    private appParameterService: AppParameterService,
    private zone: NgZone
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    this.remoteActionBuilderService.newBuild(
      new TravelRemoteActionBuilder(
        TravelRemoteActionType.DEPART,
        this.appService,
        this.credentialsService,
        this.servicejobService,
        this.branchesService,
        this.locationService,
        this.employeeService,
        this.jobSectionsService,
        this.clientStateService,
        this.appParameterService,
        this.logger,
        params && params['allowGPTarget'] ? params['allowGPTarget'] : false
      )
    );
    this.zone.run(() => {
      this.navigationController.navigateForward('/feature/remote-action');
    });
  }

  // Private Functions
}
